<template>
<div class="header" :class="orderNum > 0 && $route.name!=='HomeWaimaiIndex' ? 'orderTop' : 'originTop' ">
  <!-- <div class='kongbai'>
    <div class="localtion" @click="goMap">
      <span>地址</span><i class="iconfont right">&#xe6ef;</i> -->
      <!-- <i class="iconfont">&#xe6ec;</i><span>{{locationName}}</span><i class="iconfont right">&#xe6ef;</i> -->
    <!-- </div>
  </div> -->
  <home-common-search class="search-wrapper"></home-common-search>
  <!-- <div class="popup-more iconfont" @click="popupMore">&#xe680;</div> -->
  <!-- <header-more v-show="popupVisible"></header-more> -->
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { MessageBox } from 'mint-ui'
import { checkAddressPosition } from '@src/util/map'
import { AddressState } from '@src/const/address'
import HomeCommonSearch from '../common/HomeCommonSearch'
import HeaderMore from '../..//HeaderMore'
export default {
  name: 'IndexHeader',
  components: {
    HomeCommonSearch,
    HeaderMore
  },
  data () {
    return {
      popupVisible: false,
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.member.info,
      member_point: state => state.member.point,
      orderNum: (state) => state.member.orderNum,
    }),
    locationName: function () {
      return this.member_point.address || this.$t('map.selectorDefault')
    }
  },
  async mounted () {    
    if (this.user === null) {
      let guestAddress = localStorage.getItem('guestAddress');

      if (guestAddress === null) {
        this.gotoCreateAddressForm(this.$t('address.please_add_receiver_address'))
        return;
      }

      guestAddress = JSON.parse(guestAddress);
      
      this.memberPoint({
        point: {
          address: guestAddress.address_detail,
          lat: guestAddress.address_latitude,
          lng: guestAddress.address_longitude
        }
      })
    } else {
      if (Object.keys(this.member_point).length === 0) {
        this.gotoCreateAddressForm(this.$t('address.please_add_receiver_address'))
        return;
      }
      
      if (await checkAddressPosition(this)) {
        return this.confirmPosition(this.member_point)
      }
    }
  },
  methods: {
    ...mapMutations({
      memberPoint: 'memberPoint'      
    }),
    confirmPosition(location) {
      MessageBox({
        title: this.$t('address.choose_addresses_too_far_away'),
        message: `${this.$t('address.address')}: ${location.address}`,
        showCancelButton: true,
        cancelButtonText: this.$t('address.choose_another_address')
      })
      .then(action => {
        if (action === "cancel") {
          this.$router.push({ name: 'MemberAddressList', query: {
            o2o_errand_type: AddressState.PICKUP_POINT,
            from: 'member_profile'
          }})
        } else {
          sessionStorage.setItem('checkAddress', 'agree')
          this.memberPoint({ point: location })
        }
      })
    },
    gotoCreateAddressForm(msg) {
      // 若是已登入狀態則導向地址列表，若是遊客狀態直接導向填寫地址頁面
      let pushData = this.user !== null ? {
        name: 'MemberAddressList',
        query: {
          o2o_errand_type: AddressState.PICKUP_POINT,
          from: 'member_profile'
        }
      } : {
        name: 'HomeMap'       
      }

      if (this.user) {
        MessageBox.alert(msg).then(() => {
          this.$router.push(pushData)
        })
      } else {
        MessageBox({
          message: '請新增地址或登入',
          showCancelButton: true,
          confirmButtonText: '新增地址',
          cancelButtonText: '登入',
          closeOnClickModal: false
        }).then(res => {          
          if (res === 'confirm') {
            this.$router.push(pushData)
          } else {
            this.$router.push({name: 'HomeMemberLogin'})
          }          
        })        
      }
    },
    popupMore () {
      if (!this.popupVisible) {
        this.popupVisible = true
      } else {
        this.popupVisible = false
      }
    }
  }
}
</script>

<style scoped>
  .header{height:2.4rem;
    color: #fff;
    /* background:#f4c41e; */
    display:flex;
    justify-content: center;
    }
  /* .header .kongbai{width: 2rem;} */
  
  .header .search-wrapper{
    /* flex:1; */
    width: 90%;
    padding-top:.5rem;
    padding:.5rem 0px .35rem 0px
  }
  .header .search-wrapper input{border-radius:50%}
  .header .localtion{ width:3.5rem; text-align: center;  position: relative;display: inline-block;z-index: 2;white-space: nowrap;padding-left:.1rem;}
  .header .localtion i{width:1rem;text-align:center;display:inline-block;line-height:2.5rem;font-size:.8rem;}
  .header .localtion i.right{font-size:.65rem}
  .header .localtion span{line-height:2.5rem;max-width:3.5rem;overflow: hidden;text-overflow: ellipsis;    display: inline-block;vertical-align: middle;font-size:.6rem;}
  .popup-more{width:1.8rem;height:2.5rem;text-align:center;line-height:2.5rem;}
</style>
